export const DEFAULT_CLOSING_FROM = '19:00';

export const APPOINTMENT_STATUS = {
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
  OPEN: 'OPEN'
};

export const APPOINTMENT_STATUSES = {
  OPEN: APPOINTMENT_STATUS.OPEN,
  CLOSED: APPOINTMENT_STATUS.CLOSED
};

export const APPOINTMENT_TASK_TYPES = {
  KEY_DEPOSIT: 'KEY_DEPOSIT',
  KEY_RETRIEVE: 'KEY_RETRIEVE',
  DRIVER_DOCUMENTS: 'DRIVER_DOCUMENTS',
  REPAIR_ORDER: 'REPAIR_ORDER',
  BILLING: 'BILLING',
  RENTAL_VEHICLE: 'RENTAL_CAR'
};

export const APPOINTMENT_TASKS_STATUS = {
  CANCELED: 'CANCELED',
  TO_START: 'TO_START',
  PREPARED: 'PREPARED',
  CHECKED: 'CHECKED'
};

export const APPOINTMENT_TASK_RENDER_TYPES = {
  CLIENT: 'CLIENT',
  RENTAL: 'RENTAL'
};

export const APPOINTMENT_MEDIAS_STATUS = {
  COMPLETED: 'COMPLETED',
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED'
};

export const MEDIAS_ACCESS_CONTROL = {
  PUBLIC: 'PUBLIC',
  USER: 'USER'
};

export const ATTENTION_POINTS_TYPE = {
  TASK: 'TASK',
  WARNING: 'WARNING',
  ISSUE: 'ISSUE'
};

export const APPOINTMENT_TASK_KEY_STATUS = {
  DROPPED: 'DROPPED',
  PICKED: 'PICKED'
};

export const ATTENTION_POINTS_ERRORS = {
  CLIENT_MESSAGES: 'CLIENT_MESSAGES',
  EXPIRED_DROPOFF_BOOKING: 'EXPIRED_DROPOFF_BOOKING',
  EXPIRED_PICKUP_BOOKING: 'EXPIRED_PICKUP_BOOKING',
  MISSING_CLIENT_INFO: 'MISSING_CLIENT_INFO',
  MISSING_CLIENT_KEY: 'MISSING_CLIENT_KEY',
  MISSING_DOCUMENTS: 'MISSING_DOCUMENTS',
  MISSING_RENTAL_KEY: 'MISSING_RENTAL_KEY',
  PREPARE_LOCKER: 'PREPARE_LOCKER',
  PREPARE_USED_LOCKER: 'PREPARE_USED_LOCKER',
  RENTAL_ISSUE: 'RENTAL_ISSUE',
  UNANSWERED_PROPOSED_WORKS: 'UNANSWERED_PROPOSED_WORKS',
  UNANSWERED_REQUIRED_WORKS: 'UNANSWERED_REQUIRED_WORKS',
  UNPAID_BILL: 'UNPAID_BILL',
  UNSIGNED_RENTAL_DOCUMENTS: 'UNSIGNED_RENTAL_DOCUMENTS',
  UNUSED_CLIENT_KEY: 'UNUSED_CLIENT_KEY',
  UNUSED_RENTAL_KEY: 'UNUSED_RENTAL_KEY',
  VERIFY_DOCUMENTS: 'VERIFY_DOCUMENTS',
  VERIFY_LOCKER: 'VERIFY_LOCKER',
  VERIFY_USED_LOCKER: 'VERIFY_USED_LOCKER'
};

export const ATTENTION_POINTS_RESOLVABLE = [
  ATTENTION_POINTS_ERRORS.MISSING_CLIENT_KEY,
  ATTENTION_POINTS_ERRORS.MISSING_RENTAL_KEY,
  ATTENTION_POINTS_ERRORS.UNUSED_CLIENT_KEY,
  ATTENTION_POINTS_ERRORS.UNUSED_RENTAL_KEY
];

export const APPOINTMENT_EVENT_TYPE_ENUM = {
  CREATE: 'CREATE',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
  DOCUMENT_ACCEPTED: 'DOCUMENT_ACCEPTED',
  DOCUMENT_ADDED: 'DOCUMENT_ADDED',
  DOCUMENT_REFUSED: 'DOCUMENT_REFUSED',
  DROP_OFF_CONFIRMED: 'DROP_OFF_CONFIRMED',
  DROP_OFF_ISSUES_MANUALLY_SOLVED: 'DROP_OFF_ISSUES_MANUALLY_SOLVED',
  DROP_OFF_LOCKER_CANCELLED: 'DROP_OFF_LOCKER_CANCELLED',
  DROP_OFF_LOCKER_CODE_GENERATED: 'DROP_OFF_LOCKER_CODE_GENERATED',
  DROP_OFF_LOCKER_INFO_SENT: 'DROP_OFF_LOCKER_INFO_SENT',
  DROP_OFF_LOCKER_OPENED: 'DROP_OFF_LOCKER_OPENED',
  DROP_OFF_LOCKER_PREPARED: 'DROP_OFF_LOCKER_PREPARED',
  DROP_OFF_LOCKER_VERIFIED: 'DROP_OFF_LOCKER_VERIFIED',
  DROP_OFF_LOCKER_VERIFIED_ISSUE: 'DROP_OFF_LOCKER_VERIFIED_ISSUE',
  ISSUE_REPORTED: 'ISSUE_REPORTED',
  ISSUE_RESOLVED: 'ISSUE_RESOLVED',
  MANUALLY_SENT: 'MANUALLY_SENT',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PICK_UP_CONFIRMED: 'PICK_UP_CONFIRMED',
  PICK_UP_ISSUES_MANUALLY_SOLVED: 'PICK_UP_ISSUES_MANUALLY_SOLVED',
  PICK_UP_LOCKER_CANCELLED: 'PICK_UP_LOCKER_CANCELLED',
  PICK_UP_LOCKER_CODE_GENERATED: 'PICK_UP_LOCKER_CODE_GENERATED',
  PICK_UP_LOCKER_INFO_SENT: 'PICK_UP_LOCKER_INFO_SENT',
  PICK_UP_LOCKER_OPENED: 'PICK_UP_LOCKER_OPENED',
  PICK_UP_LOCKER_PREPARED: 'PICK_UP_LOCKER_PREPARED',
  PICK_UP_LOCKER_VERIFIED: 'PICK_UP_LOCKER_VERIFIED',
  PICK_UP_LOCKER_VERIFIED_ISSUE: 'PICK_UP_LOCKER_VERIFIED_ISSUE',
  READ: 'READ',
  RENTAL_DOCUMENTS_SIGNED: 'RENTAL_DOCUMENTS_SIGNED',
  REOPENED: 'REOPENED',
  REPAIR_ORDER_ANSWERED: 'REPAIR_ORDER_ANSWERED',
  SENT: 'SENT',
  UPDATE: 'UPDATE'
};

export const APPOINTMENT_DATA = 'APPOINTMENT_DATA';

export const CUSTOMER_DATA = 'CUSTOMER_DATA';
